var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-scrollbar',{attrs:{"wrap-class":"scrollbar-wrapper"}},[_c('logo',{attrs:{"collapse":_vm.isCollapse}}),_vm._v(" "),_c('el-menu',{attrs:{"default-active":_vm.$route.path,"collapse":_vm.isCollapse,"background-color":_vm.variables.menuBg,"text-color":_vm.variables.menuText,"active-text-color":_vm.variables.menuActiveText,"collapse-transition":false,"mode":"vertical"}},_vm._l((_vm.permission_routes),function(route){return _c('sidebar-item',{key:route.path,attrs:{"item":route,"base-path":route.path}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/layout/components/Sidebar/index.vue?vue&type=template&id=18922cce&
// module id = null
// module chunks = 